import { render } from "./CGridButtonColumn.vue?vue&type=template&id=eb6c0bc2&scoped=true"
import script from "./CGridButtonColumn.vue?vue&type=script&lang=js"
export * from "./CGridButtonColumn.vue?vue&type=script&lang=js"

import "./CGridButtonColumn.vue?vue&type=style&index=0&id=eb6c0bc2&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb6c0bc2"]])

export default __exports__